"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SoilDiv;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LNumInp_1 = require("../client/inputs/body/LNumInp");
var CalcBtn_1 = require("../client/buttons/CalcBtn");
function SoilDiv() {
    var inpRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(""), v = _a[0], setV = _a[1];
    return ((0, jsx_runtime_1.jsxs)("div", { id: "soilDiv", children: [(0, jsx_runtime_1.jsx)(LNumInp_1.default, { name: "soil_quant", id: "soilQuant", title: "Quantidade de Solo", s: v, d: setV, r: inpRef, large: true, group: "main" }), (0, jsx_runtime_1.jsx)(CalcBtn_1.default, { id: "main", group: "main" })] }));
}
